import React, { useEffect, useState } from "react";
import { checkWidgetAdminOrNot, URL } from "../../../utils/Constants";
import { axiosPost } from "../../../utils/AxiosApi";
import moment from "moment";
import { adToBS, bsToAD, NepaliCalendar } from "nepali-calander";
import * as htmlToImage from "html-to-image";
import { Spinner } from "reactstrap";
import ListAllCalendarEvents from "./ListAllCalendarEvents";
import { groupBy } from "lodash";

const UpdatedAllCalendar = () => {
  // Widget events
  const [widgetEvents, setWidgetEvents] = useState([]);

  // Current Academic Year
  const [currentAcYr, setCurrentAcYr] = useState("");
  const [currentAcYrId, setCurrentAcYrId] = useState("");
  const [currentAcYrName, setCurrentAcYrName] = useState("");

  // Dates array
  const [dates, setDates] = useState([]);
  // BS months array (unique)
  const [bsMonths, setBsMonths] = useState([]);

  // Filtered / calendar events
  const [filteredWidgetEvents, setFilteredWidgetEvents] = useState([]);
  const [allCalendarEventTitle, setAllCalendarEventTitle] = useState([]);
  const [allHolidayEvents, setAllHolidayEvents] = useState([]);

  // UI states
  const [spinner, setSpinner] = useState(false);
  const [eventhavingSameName, setEventHavingSameName] = useState("");
  const [permissionModal, setPermissionModal] = useState(false);

  // School info
  const [schoolInfos, setSchoolInfos] = useState(null);

  // Other flags
  const [downloadClicked, setDownloadClicked] = useState(false);
  const [adCalendar, setAdCalendar] = useState(true);
  const [bsCalendar, setBsCalendar] = useState(false);

  useEffect(() => {
    getUserCurrentAcademicYear();
    getWidgetEvents();
    getSchoolInfo();
    // renderNepaliDates();
  }, []);

  useEffect(() => {
    getAcYrDate();
  }, [currentAcYr]);
  console.log(currentAcYr, "Current Academic Year");

  useEffect(() => {
    if (dates.length > 0 && currentAcYr) {
      // Convert start and end dates to BS
      const startDateBS = adToBS(
        moment(currentAcYr.startDate).format("YYYY-MM-DD"),
      );
      const endDateBS = adToBS(
        moment(currentAcYr.endDate).format("YYYY-MM-DD"),
      );

      if (!startDateBS || !endDateBS) {
        return;
      }

      // Strategy: Find BS months that contain days 1, 15, and last day of each AD month
      // This should cover all BS months that contain any part of the AD months
      const uniqueBSMonths = new Map();

      dates.forEach((date) => {
        const adYear = parseInt(moment(date).format("YYYY"));
        const adMonth = parseInt(moment(date).format("MM"));

        // Check days 1, 15, and last day of the AD month
        const targetDays = [1, 15];
        const lastDayOfMonth = moment(date).endOf("month").date();
        if (lastDayOfMonth !== 15) {
          targetDays.push(lastDayOfMonth);
        }

        targetDays.forEach((adDay) => {
          const convertedDate = adToBS(adYear, adMonth, adDay);
          if (convertedDate) {
            const bsKey = `${convertedDate.bs_y}-${convertedDate.bs_m}`;
            if (!uniqueBSMonths.has(bsKey)) {
              uniqueBSMonths.set(bsKey, {
                bsYear: convertedDate.bs_y,
                bsMonth: convertedDate.bs_m,
                adYear: adYear,
                adMonth: adMonth,
              });
            }
          }
        });
      });

      // Sort BS months by year and month
      const sortedBSMonths = Array.from(uniqueBSMonths.values()).sort(
        (a, b) => {
          if (a.bsYear !== b.bsYear) {
            return a.bsYear - b.bsYear;
          }
          return a.bsMonth - b.bsMonth;
        },
      );

      // Verify we have unique BS months
      const uniqueKeys = new Set(
        sortedBSMonths.map((m) => `${m.bsYear}-${m.bsMonth}`),
      );
      if (uniqueKeys.size !== sortedBSMonths.length) {
        console.warn("Duplicate BS months detected!", sortedBSMonths);
      }

      console.log(
        "Setting BS months:",
        sortedBSMonths.map((m) => `${m.bsYear}-${m.bsMonth}`),
      );
      setBsMonths(sortedBSMonths);
    }
  }, [dates, currentAcYr]);
  useEffect(() => {
    manipulateWidgetEvent();
  }, [widgetEvents]);

  const getSchoolInfo = () => {
    axiosPost(URL.getSchoolByKey, {}, (response) => {
      if (response.status === 200) {
        setSchoolInfos(response.data.data);
      }
    });
  };

  const getWidgetEvents = () => {
    axiosPost(URL.getEvents, {}, async (responseWidgets) => {
      if (responseWidgets.status === 200) {
        axiosPost(URL.getWeekDaysByEduDiv, {}, (response) => {
          if (response.status === 200) {
            let newEvents = [...responseWidgets.data.data];
            newEvents.forEach((event) => {
              event.end = moment(event.end).format("YYYY-MM-DD");
              event.start = moment(event.start).format("YYYY-MM-DD");
            });
            setWidgetEvents([...newEvents]);
          }
        });
      }
    });
  };

  const manipulateWidgetEvent = () => {
    let widgetEventsCopy = [...widgetEvents];
    const unique = [];
    widgetEventsCopy.map((x) =>
      unique.filter(
        (a) =>
          a.color == x.color &&
          a.title == x.title &&
          a.start == x.start &&
          a.end == x.end,
      ).length > 0
        ? null
        : unique.push(x),
    );

    const reqEvent = unique.map((el) => ({
      eventTypeName: el.eventTypeName,
      color: el.color,
      start: el.start,
      end: el.end,
      title: el.title,
      holiday: el.isHoliday,
    }));

    const filteredReqEvent = [];
    reqEvent.map((x) =>
      filteredReqEvent.filter((a) => a.color == x.color).length > 0
        ? null
        : filteredReqEvent.push(x),
    );

    const filterNullValue = filteredReqEvent.filter(
      (el) => el.eventTypeName !== null && el.eventTypeName !== undefined,
    );
    let dataWithSameEventName = [];
    unique.forEach((el, id) => {
      filterNullValue.forEach((evnt, id) => {
        if (evnt.eventTypeName === el.eventTypeName) {
          return dataWithSameEventName.push(el);
        }
      });
      el.end = moment(el.end).format("YYYY-MM-DD");
      el.start = moment(el.start).format("YYYY-MM-DD");
    });

    const groupByEventTypeName = groupBy(
      dataWithSameEventName,
      (d) => d.eventTypeName,
    );

    const allHolidayEvents = unique.filter((el) => el.isHoliday === true);
    setFilteredWidgetEvents(unique);
    setAllCalendarEventTitle(filterNullValue);
    setAllHolidayEvents(allHolidayEvents);
    setEventHavingSameName(groupByEventTypeName);
  };

  const getUserCurrentAcademicYear = () => {
    axiosPost(URL.selectUserAcademicYear, {}, (response) => {
      if (response.status === 200) {
        if (response.data.data) {
          setCurrentAcYr(response.data.data);
          setCurrentAcYrId(response.data.data.id);
          setCurrentAcYrName(response.data.data.name);
        } else {
          getCurrentAcademicYear();
        }
      }
    });
  };

  const getAcYrDate = () => {
    if (!!currentAcYr) {
      let startDates = moment(currentAcYr.startDate).format("YYYY-MM-DD");
      let endDates = moment(currentAcYr.endDate).format("YYYY-MM-DD");
      let newDates = [];

      const start = moment(startDates).startOf("month");
      const end = moment(endDates);

      let current = start.clone();

      while (current <= end) {
        newDates.push(current.format("YYYY-MM-DD"));
        current.add(1, "month");
      }
      setDates(newDates);
    }
  };
  const getCurrentAcademicYear = () => {
    let data = {
      isCurrent: "true",
    };
    axiosPost(URL.getAcademicYears, data, (response) => {
      if (response.status === 200) {
        setCurrentAcYr(response.data.data[0]);
        setCurrentAcYrId(response.data.data[0].id);
        setCurrentAcYrName(response.data.data[0].name);
      }
    });
  };

  const handleCalendarEventDownload = async () => {
    try {
      var i;
      let todayBorder = document.getElementsByClassName("fc-day");

      for (i = 0; i < todayBorder.length; i++) {
        todayBorder[i].classList.remove("fc-today");
      }
      setSpinner(true);
      setDownloadClicked(true);

      const dataUrl = await htmlToImage.toJpeg(
        document.getElementById("printEvent"),
        {
          quality: 1.0,
          backgroundColor: "white",
        },
      );
      const link = document.createElement("a");
      link.download = "Calendar.png";
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Error generating calendar image:", error);
    } finally {
      setSpinner(false);
      setDownloadClicked(false);
    }
  };
  return (
    <>
      <div className="container-fluid">
        <div className="tt-group-header mt-2">
          All Calendars
          {checkWidgetAdminOrNot("Academic Administration") ? (
            <button
              className="tt-button tt-button-primary float-right permissionBtnCSS"
              onClick={() => {
                setPermissionModal((prev) => !prev);
              }}
            >
              Permissions
            </button>
          ) : null}
        </div>
        <div className="row mt-2 mb-2">
          <div className="col text-right">
            {widgetEvents?.length > 0 ? (
              <button
                disabled={downloadClicked}
                className="tt-button tt-button-primary"
                onClick={() => handleCalendarEventDownload()}
              >
                Download
              </button>
            ) : null}
          </div>
        </div>
        <div className="row" id="printEvent">
          <div
            className="col-md tt-adjustPadding tt-widgetContent-tab-holder"
            style={{ height: "auto" }}
          >
            <div className="tt-adjustPadding">
              <div className="container-fluid row calendar-print-header my-3">
                <div className="col-md-3 d-flex align-items-center justify-content-center ml-5">
                  <img
                    src={URL.imageSelectURL + schoolInfos?.imageName}
                    className="img-fluid"
                  />
                </div>

                <div className="col-md-5 d-flex align-items-center justify-content-center flex-column ml-3">
                  <h2 className="text-center">{schoolInfos?.name}</h2>
                  <h5 className="text-center">{schoolInfos?.address}</h5>
                  <h6 className="text-center">{currentAcYrName}</h6>
                </div>
                <div className="col-md-4"></div>
              </div>
              <div
                className="tt-displayDate d-flex"
                style={{
                  height: "auto",
                  overflowY: "visible",
                  justifyContent: "space-evenly",
                }}
              >
                {bsMonths.length > 0 &&
                  bsMonths.map((bsMonthData, idx) => {
                    // Convert BS month to AD to provide both props (prevents hook from using current date)
                    // BS props take precedence, but AD props prevent the "use current date" branch
                    const adDate = bsToAD(
                      bsMonthData.bsYear,
                      bsMonthData.bsMonth,
                      15,
                    );

                    // Critical: Use BS year and month as the key to ensure React creates separate instances
                    const calendarKey = `nepali-cal-${bsMonthData.bsYear}-${bsMonthData.bsMonth}`;

                    return (
                      <div
                        className="tt-widgetContent-tab-holder allCalendarDisplay m-3"
                        style={{ width: "430px" }}
                        key={`wrapper-${calendarKey}-${idx}`}
                      >
                        <NepaliCalendar
                          // Key must be unique per BS month - this forces React to create new instance
                          key={calendarKey}
                          // BS props take highest precedence - these are the source of truth
                          bsYear={bsMonthData.bsYear}
                          bsMonth={bsMonthData.bsMonth}
                          // AD props prevent hook from using current date (BS props still take precedence)
                          year={adDate ? adDate.ad_y : undefined}
                          month={adDate ? adDate.ad_m : undefined}
                          // Must be 'bs' mode to respect bsYear/bsMonth props
                          calendarMode={localStorage.getItem("calendar-mode")}
                          events={filteredWidgetEvents || []}
                          showToggle={false}
                          holidayWeekdays={["Saturday"]}
                          isClickable={false}
                          showNationalHolidayToggle={false}
                          showNationalHoliday={false}
                          showArrows={false}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
        <ListAllCalendarEvents
          events={filteredWidgetEvents}
          eventsTitle={allCalendarEventTitle}
          holidayEvents={allHolidayEvents}
          eventsWithSameEventType={eventhavingSameName}
        />
      </div>
      {spinner ? (
        <div className="fullWindow-Spinner">
          <div>
            <Spinner color="white"></Spinner>
          </div>
          <div style={{ fontSize: "16px", marginTop: "15px" }}>
            Please wait... Downloading Academic Events
          </div>
        </div>
      ) : null}
    </>
  );
};

export default UpdatedAllCalendar;
